import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader-mod/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "right",
  "use": "right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right\"><defs><style></style></defs><path d=\"M693.333 512c0 14.933-4.266 29.867-14.933 40.533L443.733 829.867c-23.466 27.733-64 29.866-89.6 8.533-27.733-23.467-29.866-64-8.533-89.6L546.133 512 345.6 275.2c-23.467-27.733-19.2-68.267 8.533-89.6 27.734-23.467 68.267-19.2 89.6 8.533L678.4 471.467c10.667 10.666 14.933 25.6 14.933 40.533z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol